import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const duplicateUpsellPage = {
  name: "duplicateUpsellPage" as const,
  input: z.object({ upsellPageId: zExt.objectId() }),
  output: z.object({ upsellPageId: zExt.objectId() }),
};
